import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/conceptstudio.com/httpdocs/frontend/src/app/[locale]/awards/index.js");
